import { PopularOption } from '@/entities/map'
import { AdditionalOption, BasicOption } from '@/entities/room'
import type { RoomIconName } from '@/entities/room'

export type Option<T> = {
  title: string
  value: T
  icon: RoomIconName
}

export const POPULAR_OPTIONS: Option<PopularOption>[] = [
  {
    title: '주차 공간',
    value: PopularOption.PARKING,
    icon: 'parking',
  },
  {
    title: '엘리베이터',
    value: PopularOption.ELEVATOR,
    icon: 'elevator',
  },
  {
    title: '반려동물 동반 가능',
    value: PopularOption.PET_ALLOWED,
    icon: 'petAllowed',
  },
  {
    title: '복층',
    value: PopularOption.DUPLEX_STRUCTURE,
    icon: 'duplexStructure',
  },
]

export const BASIC_OPTIONS: Option<BasicOption>[] = [
  {
    title: '냉장고',
    value: BasicOption.REFRIGERATOR,
    icon: 'refrigerator',
  },
  {
    title: '세탁기',
    value: BasicOption.WASHING_MACHINE,
    icon: 'washingMachine',
  },
  {
    title: '에어컨',
    value: BasicOption.AIR_CONDITIONER,
    icon: 'airConditioner',
  },
  {
    title: 'TV',
    value: BasicOption.TV,
    icon: 'tv',
  },
  {
    title: '와이파이',
    value: BasicOption.WIFI,
    icon: 'wifi',
  },
  {
    title: '싱크대',
    value: BasicOption.SINK,
    icon: 'sink',
  },
  {
    title: '가스레인지',
    value: BasicOption.GAS_STOVE,
    icon: 'gasStove',
  },
  {
    title: '인덕션',
    value: BasicOption.INDUCTION,
    icon: 'induction',
  },
  {
    title: '침대',
    value: BasicOption.BED,
    icon: 'bed',
  },
]

export const ADDITIONAL_OPTIONS: Option<AdditionalOption>[] = [
  {
    title: '도어락',
    value: AdditionalOption.DOOR_LOCK,
    icon: 'doorlock',
  },
  {
    title: 'CCTV',
    value: AdditionalOption.CCTV,
    icon: 'cctv',
  },
  {
    title: '관리실',
    value: AdditionalOption.MANAGEMENT_OFFICE,
    icon: 'managementOffice',
  },
  {
    title: '식탁',
    value: AdditionalOption.DINING_TABLE,
    icon: 'diningTable',
  },
  {
    title: '전자레인지',
    value: AdditionalOption.MICROWAVE,
    icon: 'microwave',
  },
  {
    title: '전기밥솥',
    value: AdditionalOption.RICE_COOKER,
    icon: 'riceCooker',
  },
  {
    title: '정수기',
    value: AdditionalOption.WATER_PURIFIER,
    icon: 'waterPurifier',
  },
  {
    title: '소파',
    value: AdditionalOption.SOFA,
    icon: 'sofa',
  },
  {
    title: '책상',
    value: AdditionalOption.DESK,
    icon: 'desk',
  },
  {
    title: '옷장',
    value: AdditionalOption.CLOSET,
    icon: 'closet',
  },
  {
    title: '신발장',
    value: AdditionalOption.SHOE_RACK,
    icon: 'shoeRack',
  },
  {
    title: '화장대',
    value: AdditionalOption.VANITY,
    icon: 'vanity',
  },
  {
    title: '욕조',
    value: AdditionalOption.BATHTUB,
    icon: 'bathtub',
  },
  {
    title: '비데',
    value: AdditionalOption.BIDET,
    icon: 'bidet',
  },
  {
    title: '건조기',
    value: AdditionalOption.DRYER,
    icon: 'dryer',
  },
  {
    title: '발코니/베란다',
    value: AdditionalOption.BALCONY,
    icon: 'balcony',
  },
  {
    title: '드레스룸',
    value: AdditionalOption.DRESSING_ROOM,
    icon: 'dressingRoom',
  },
  {
    title: '케이블 TV',
    value: AdditionalOption.CABLE_TV,
    icon: 'cableTV',
  },
  {
    title: '커튼',
    value: AdditionalOption.CURTAINS,
    icon: 'curtain',
  },
  {
    title: '공기청정기',
    value: AdditionalOption.AIR_PURIFIER,
    icon: 'airPurifier',
  },
]
